const getRegion = () => {
  const region = new URLSearchParams(window.location.search).get("region");
  const host = window.location.host;
  if (region === "hmt" || host.includes("hmt") || host.includes("gnjoy")) {
    return "hmt";
  } else if (host.includes("roglobal")) {
    return "sea";
  }
  return "sea";
};

export { getRegion };
